<div class="attachments-panel">
  <div class="panel-title">{{ label }}</div>

  @if (attachments?.length) {
    <div class="attachments-scroll">
      @for (file of attachments; track file) {
        <div class="attachments-row">
          <div class="file-name" [title]="file.fileNameOriginal || file.name">
            {{ file.fileNameOriginal || file.name }}
          </div>
          <div class="actions">
            @if (readonlyAttachmentsPanel == false) {
              <button class="btn btn-outline-danger btn-icon"
                (click)="confirmDelete(file)">
                <i class="fa fa-solid fa-trash"></i>
              </button>
            }
            <button class="btn btn-outline-secondary btn-icon" (click)="viewFile(file)">
              <i class="fa fa-solid fa-file"></i>
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    @if (readonlyAttachmentsPanel == false) {
      <div class="empty-text">No attachments yet</div>
    }
  }


  @if (readonlyAttachmentsPanel == false) {
    <div class="add-file">
      <input type="file" #fileInput (change)="onFileSelected($event)" class="hidden-file-input" />
      <button class="btn btn-primary" [disabled]="proposal === undefined || proposal === null"
        (click)="fileInput.click()">
        <i class="fa fa-solid fa-plus"></i> Add another file
      </button>
    </div>
  }
</div>
